import { useState, useEffect, useContext } from "react";
import axios from "axios";
import AddUser from "./AddUser";
import EditUser from "./EditUser";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Context/AuthContext";
import TableComponent from "../../../utils/TableComponent";
import { Authorization } from "../../../Context/Authorization";

const ManageUser = () => {
  const [users, setUsers] = useState([]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const { permissions } = useContext(AuthContext);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchUsers = async () => {
      const Confiq = Authorization();
      try {
        const response = await axios.get(`${Api}/api/users/user`, Confiq);
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users", error);
      }
    };
    fetchUsers();
  }, [Api]);

  const handleShowEditPopup = async (user) => {
    const Confiq = Authorization();
    try {
      const response = await axios.get(`${Api}/api/users/user/${user._id}`, Confiq);
      setCurrentUser(response.data);
      setShowEditPopup(true);
    } catch (error) {
      console.error("Error fetching user details", error);
      toast.error("Failed to load user details");
    }
  };

  const handleCloseEditPopup = () => {
    setShowEditPopup(false);
    setCurrentUser(null);
  };

  const handleDeleteUser = async (id) => {
    if (!window.confirm("Are you sure you want to delete this User?")) return;
    try {
      const Confiq = Authorization();
      await axios.delete(`${Api}/api/users/user/${id}`, Confiq);
      setUsers(users.filter((user) => user._id !== id));
      toast.success("User deleted successfully");
    } catch (error) {
      console.error("Error deleting user", error);
      toast.error("Error deleting user");
    }
  };

  const handleAddUser = (newUser) => { setUsers([...users, newUser]); };
  const handleEditUser = (updatedUser) => {
    setUsers(users.map((user) => (user._id === updatedUser._id ? updatedUser : user)));
  };

  const columns = [
    { headerName: "SI.No", field: "index", valueGetter: (params) => params.node.rowIndex + 1 },
    { headerName: "Name", field: "name" },
    { headerName: "Username", field: "username" },
    { headerName: "Email", field: "email" },
    { headerName: "Designation", field: "designation" },
    { headerName: "Role", field: "role.roleName" },
    {
      headerName: "Action", field: "action",
      cellRenderer: (params) => (
        <div>
          {permissions.includes("EditUser") && (
            <i className="mdi mdi-pen" style={{ fontSize: "1.5rem", cursor: "pointer" }}
              onClick={() => handleShowEditPopup(params.data)} />
          )}
          {permissions.includes("DeleteUser") && (
            <i className="mdi mdi-delete" style={{ fontSize: "1.5rem", cursor: "pointer" }}
              onClick={() => handleDeleteUser(params.data._id)} />
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Users</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>User</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Manage Users</span>
        </div>
      </div>

      {/* ── Table Card ── */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
            <i className="mdi mdi-account-multiple" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#fff", flex: 1 }}>User Records</span>
          {permissions.includes("AddRole") && (
            <button type="button" onClick={() => setShowAddPopup(true)}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 14px", background: "rgba(255,255,255,0.15)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)", borderRadius: 7, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
              <i className="mdi mdi-plus" /> Create New
            </button>
          )}
        </div>
        <div style={{ padding: 16 }}>
          <TableComponent data={users} columns={columns} />
        </div>
      </div>

      {showAddPopup && <AddUser onClose={() => setShowAddPopup(false)} onAddUser={handleAddUser} />}
      {showEditPopup && currentUser && (
        <EditUser user={currentUser} onClose={handleCloseEditPopup} onEditUser={handleEditUser} />
      )}
    </div>
  );
};

export default ManageUser;
